// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pRmMe","section":"styles_section__e65-M"};